import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/root';
import * as Sentry from '@sentry/browser';
import 'draft-js/dist/Draft.css';
import {versionManager} from './version_manager';

// eslint-disable-next-line no-console
console.log('using graphql server: ', process.env.GRAPHQL_ENDPOINT);

if (process.env.SENTRY_CONFIG && process.env.SENTRY_CONFIG !== '') {
	Sentry.init({
		dsn: process.env.SENTRY_CONFIG,
		release: `web-front@${versionManager.getClientMajorVersion()}.${versionManager.getClientMinorVersion()}`,
		ignoreErrors: ["can't access dead object"],
	});
}

ReactDOM.render(<Root />, document.getElementById('app'));

if (process.env.NODE_ENV !== 'production') {
	module.hot.accept();
}
